import TableOfContentsHeading from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/table_of_contents_heading.vue?vue3';
export default {
    name: 'TableOfContents',
    components: {
        TableOfContentsHeading
    },
    props: {
        headings: {
            type: Array,
            required: true
        }
    }
};
